var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right panel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3334 13.3334C13.7001 13.3334 14.014 13.2029 14.2751 12.9417C14.5362 12.6806 14.6667 12.3667 14.6667 12.0001V4.00008C14.6667 3.63341 14.5362 3.31953 14.2751 3.05841C14.014 2.7973 13.7001 2.66675 13.3334 2.66675H2.66675C2.30008 2.66675 1.98619 2.7973 1.72508 3.05841C1.46397 3.31953 1.33341 3.63341 1.33341 4.00008V12.0001C1.33341 12.3667 1.46397 12.6806 1.72508 12.9417C1.98619 13.2029 2.30008 13.3334 2.66675 13.3334H13.3334ZM9.33341 12.0001H2.66675V4.00008H9.33341V12.0001ZM10.6667 12.0001V4.00008H13.3334V12.0001H10.6667Z",
    fill: "#282829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPanel);
export default __webpack_public_path__ + "static/media/right_panel.fd3568742ab03a5050382d64f097977f.svg";
export { ForwardRef as ReactComponent };